<template>
    <div>
        <el-table :data="sheetToImport" border style="width: 100%" empty-text="沒有資料" height="300px">
            <el-table-column type="index" label="#" width="50" fixed></el-table-column>
            <el-table-column label="匯入狀態" show-overflow-tooltip prop="status" width="100" fixed>
                <template slot-scope="scope">
                    <span :class="getImportStatus(scope.row.importStatus)"> {{ getImportMsg(scope.row.importStatus) }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="stMap.typ" :prop="stMap.typ" width="130" />
            <el-table-column :label="stMap.employee" :prop="stMap.employee" width="130" />
            <el-table-column :label="stMap.eml" show-overflow-tooltip :prop="stMap.eml" width="250" />
            <el-table-column :label="stMap.nam" :prop="stMap.nam" width="120" />
            <el-table-column :label="stMap.idNumber" :prop="stMap.idNumber" width="120" />
            <el-table-column :label="stMap.pJ_NO" :prop="stMap.pJ_NO" width="200" />
            <el-table-column :label="stMap.deP_SNO" :prop="stMap.deP_SNO" width="80" />
            <el-table-column :label="stMap.boS_SNO" :prop="stMap.boS_SNO" width="80" />
            <el-table-column :label="stMap.mem" show-overflow-tooltip :prop="stMap.mem" width="200" />

            <el-table-column :label="stMap.stafF_BNK_BOO" :prop="stMap.stafF_BNK_BOO" width="80" />
            <el-table-column :label="stMap.stafF_BNK_DOO" :prop="stMap.stafF_BNK_DOO" width="80" />
            <el-table-column :label="stMap.stafF_BNK_ACC" :prop="stMap.stafF_BNK_ACC" width="120" />
            <el-table-column :label="stMap.stafF_BNK_TPC" :prop="stMap.stafF_BNK_TPC" width="120" />

            <el-table-column :label="stMap.grP_NO" :prop="stMap.grP_NO" width="80" />
        </el-table>
    </div>
</template>

<script>
import stMap from '@/components/dashboard/Settings/UserSetting/BatchImportDialogViews/labelFieldMap';

export default {
    props: {
        sheetToImport: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        stMap() {
            return stMap;
        },
    },
    methods: {
        getImportMsg(importStatus) {
            switch (importStatus) {
            case 'init':
                return '---';
            case 'importing':
                return '匯入中...';
            default:
                return importStatus;
            }
        },
        getImportStatus(importStatus) {
            switch (importStatus) {
            case '已新增':
                return 'success';
            case 'init':
            case 'importing':
                return '';
            default:
                return 'error';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.success {
    color: #44bf00;
    &::before {
        content: "Ｏ";
    }
}
.error {
    color: red;
    &::before {
        content: "Ｘ";
    }
}
</style>
